module.exports = __webpack_public_path__ + "static/media/IMG_3048.07da0f84.jpg";